import classNames from "classnames";
import { BandKey } from "../../types";
import styles from "./style.module.scss";

interface BandBadgeProps {
  band: BandKey | string;
  /** Falls back to the Healthy/Slipping/Dead palette when omitted. */
  bg?: string;
  color?: string;
  title?: string;
  /** The denser 12px/600 treatment the design uses for plan and payment status. */
  status?: boolean;
  className?: string;
}

/** Rounded status pill used for bands, plan status and payment status. */
function BandBadge({
  band,
  bg,
  color,
  title,
  status,
  className,
}: BandBadgeProps) {
  // "In review" looks up `.in_review`: class names can't hold a space.
  const preset = styles[String(band).toLowerCase().replace(/\s+/g, "_")];

  return (
    <span
      title={title}
      className={classNames(
        styles.badge,
        status && styles.status,
        !bg && preset,
        className
      )}
      style={bg ? { background: bg, color } : undefined}
    >
      {band}
    </span>
  );
}

export default BandBadge;
